var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('framework-loader'),_c('framework-sidebar'),_c('framework-topbar'),_c('framework-view'),_c('framework-snackbar-stack')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }